module.exports = __webpack_public_path__ + "img/012-innovation.46e19faf.svg";